import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
  updateCustomerLoginEmailField,
  updateCustomerLoginPasswordField,
  runCustomerLoginFormValidations,
  resetForm,
} from '../../actions/index'
import { customerLogin } from '../../actions/apiRequest'
import LoginFormComponent from '../../components/LoginForm'

const mapStateToProps = (state) => ({
  ...state.loginForm,
  isNewUser: false,
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  onEmailChange: (e) => {
    const email = e.target.value
    dispatch(updateCustomerLoginEmailField(email))
    dispatch(runCustomerLoginFormValidations())
  },
  onPasswordChange: (e) => {
    const password = e.target.value
    dispatch(updateCustomerLoginPasswordField(password))
    dispatch(runCustomerLoginFormValidations())
  },
  onSubmit: (e) => {
    e.preventDefault()
    dispatch(customerLogin(ownProps.history))
  },
  onMount: () => {
    dispatch(resetForm())
  },
})

const LoginForm = connect(
  mapStateToProps,
  mapDispatchToProps,
)(LoginFormComponent)

export default withRouter(LoginForm)
